import { taxonomiesCache } from "#/lib/taxonomies/taxonomies_cache";
import type { Taxonomy, TaxonomyTag } from "#/types/types";

export function taxonomyById(id: number): Taxonomy | undefined {
  return taxonomiesCache.find((taxonomy) => taxonomy.id === id);
}

export function taxonomiesByTag(tag: TaxonomyTag): Taxonomy[] {
  return taxonomiesCache.filter((taxonomy) => taxonomy.tags.includes(tag));
}
